import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';

@Component({
  selector: 'yard-transport-scope-condition-editor',
  standalone: false,
  templateUrl: './transport-scope-condition-editor.component.html',
  styleUrl: './transport-scope-condition-editor.component.scss',
})
export class TransportScopeConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    train: new FormControl(false, []),
    trailer: new FormControl(false, []),
    swapTrailer: new FormControl(false, []),
    semiTrailerTruck: new FormControl(false, [])
  });


  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        // this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      let data = '';
      if (value.train) {
        if (data != '') {data += ',';}
        data+='TRAIN';
      }
      if (value.trailer) {
        if (data != '') {data += ',';}
        data+='TRAILER';
      }
      if (value.swapTrailer) {
        if (data != '') {data += ',';}
        data+='SWAP_TRAILER';
      }
      if (value.semiTrailerTruck) {
        if (data != '') {data += ',';}
        data+='SEMI_TRAILER_TRUCK';
      }
      this.condition.data = data;
    });

  }

}
